/**
 * IMPORTS
 */

import { useMutation } from "@tanstack/react-query";

// typings
import {
  IRecepcaoLiberarRemessaClientePayload,
  IRecepcaoLiberarRemessaClienteResponse,
} from "@/hooks/liberar-remessa/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleRecepcaoLiberarRemessaCliente } from "@/domain/use-cases/liberar-remessa";
import { notifyAlert, notifyError, notifySuccess } from "@/utils/notify-messages";

export function useRecepcaoLiberarRemessaCliente() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    IRecepcaoLiberarRemessaClienteResponse,
    Error,
    IRecepcaoLiberarRemessaClientePayload
  >({
    mutationFn: async (payload) => {
      const formData = new FormData();

      formData.append("remessa_id", String(payload.remessa_id));
      formData.append("user_id_executor", String(payload.user_id_executor));
      formData.append("tipo_entrega_id", String(payload?.tipo_entrega_id));
      formData.append("file_path", payload.file_path || "");
      formData.append("observacao", payload.observacao!); // aqui você envia a data no formato ISO
      formData.append("outros", payload.outros ?? "");

      return await handleRecepcaoLiberarRemessaCliente(token!, formData as any);
    },
    onSuccess: async ({ data, message }) => {
      if (!data) {
        notifyAlert(message);
        return;
      }
      notifySuccess("Remessa liberada para o cliente com sucesso!");
    },
    onError: async () => {
      notifyError("Houve um problema ao tentar liberar a remessa para um cliente!");
    },
  });

  return {
    recepcaoLiberarRemessaCliente: mutation.mutate, // chamada direta
    recepcaoLiberarRemessaClienteAsync: mutation.mutateAsync, // se quiser await
    isLoadingLiberarRemessa: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
